import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import { i18n } from "discourse-i18n";
import DropdownSelectBoxComponent from "select-kit/components/dropdown-select-box";
import { selectKitOptions } from "select-kit/components/select-kit";
import NotificationsFilterHeader from "./notifications-filter/notifications-filter-header";
const NotificationsFilter = dt7948.c(class NotificationsFilter extends DropdownSelectBoxComponent {
  nameProperty = "label";
  get content() {
    return [{
      id: "all",
      label: i18n("user.user_notifications.filters.all")
    }, {
      id: "read",
      label: i18n("user.user_notifications.filters.read")
    }, {
      id: "unread",
      label: i18n("user.user_notifications.filters.unread")
    }];
  }
  static {
    dt7948.n(this.prototype, "content", [computed]);
  }
}, [selectKitOptions({
  headerComponent: NotificationsFilterHeader
}), classNames("notifications-filter")]);
export default NotificationsFilter;